import { fromJS } from 'immutable';

import {
  FETCH_SPECS_LIST_STARTED,
  FETCH_SPECS_LIST_SUCCESS,
  FETCH_SPECS_LIST_FAILURE,
  FETCH_SPEC_DETAILS_STARTED,
  FETCH_SPEC_DETAILS_SUCCESS,
  FETCH_SPEC_DETAILS_FAILURE,
  SAVE_SPEC_STARTED,
  SAVE_SPEC_SUCCESS,
  SAVE_SPEC_FAILURE,
  SET_CURRENT_SPEC,
  CLEAR_CURRENT_SPEC,
  FETCH_HEALTH_STARTED,
  FETCH_HEALTH_SUCCESS,
  FETCH_HEALTH_FAILURE,
  DELETE_SPEC_STARTED,
  DELETE_SPEC_SUCCESS,
  DELETE_SPEC_FAILURE,
  SAVE_ENDPOINT_SETTING_STARTED,
  SAVE_ENDPOINT_SETTING_SUCCESS,
  SAVE_ENDPOINT_SETTING_FAILURE,
  UPDATE_UPSTREAM_STARTED,
  UPDATE_UPSTREAM_SUCCESS,
  UPDATE_UPSTREAM_FAILURE,
  FETCH_GLOBAL_CONFIG_STARTED,
  FETCH_GLOBAL_CONFIG_SUCCESS,
  FETCH_GLOBAL_CONFIG_FAILURE,
  UPDATE_GLOBAL_CONFIG_STARTED,
  UPDATE_GLOBAL_CONFIG_SUCCESS,
  UPDATE_GLOBAL_CONFIG_FAILURE,
  FETCH_ENVIRONMENTS_STARTED,
  FETCH_ENVIRONMENTS_SUCCESS,
  FETCH_ENVIRONMENTS_FAILURE,
  CREATE_ENVIRONMENT_STARTED,
  CREATE_ENVIRONMENT_SUCCESS,
  CREATE_ENVIRONMENT_FAILURE,
  DELETE_ENVIRONMENT_STARTED,
  DELETE_ENVIRONMENT_SUCCESS,
  DELETE_ENVIRONMENT_FAILURE,
  FETCH_ENVIRONMENT_DETAIL_STARTED,
  FETCH_ENVIRONMENT_DETAIL_SUCCESS,
  FETCH_ENVIRONMENT_DETAIL_FAILURE,
  SET_ACTIVE_ENVIRONMENT,
  UPSERT_ENV_SPEC_SETTING_STARTED,
  UPSERT_ENV_SPEC_SETTING_SUCCESS,
  UPSERT_ENV_SPEC_SETTING_FAILURE,
  UPSERT_ENV_ENDPOINT_SETTING_STARTED,
  UPSERT_ENV_ENDPOINT_SETTING_SUCCESS,
  UPSERT_ENV_ENDPOINT_SETTING_FAILURE,
} from './actions.js';

export const initialState = {
  specsList: [],
  specsListLoading: false,
  specsListError: null,
  selectedSpec: null,
  specDetailsLoading: false,
  specDetailsError: null,
  currentSpec: null,
  saveLoading: false,
  saveError: null,
  health: null,
  healthLoading: false,
  healthError: null,
  deleteLoading: false,
  deleteError: null,
  endpointSettingSaving: false,
  endpointSettingSaveError: null,
  lastSavedEndpointSetting: null,
  upstreamUpdating: false,
  upstreamUpdateError: null,
  globalConfig: null,
  globalConfigLoading: false,
  globalConfigError: null,
  globalConfigUpdating: false,
  globalConfigUpdateError: null,
  environments: [],
  environmentsLoading: false,
  environmentsError: null,
  activeEnvironment: null,
  environmentDetail: null,
  environmentDetailLoading: false,
  createEnvironmentLoading: false,
  createEnvironmentError: null,
  deleteEnvironmentLoading: false,
  deleteEnvironmentError: null,
  envSpecSettingUpdating: false,
  envSpecSettingError: null,
  envEndpointSettingUpdating: false,
  envEndpointSettingError: null,
};

const reducers = {
  [FETCH_SPECS_LIST_STARTED]: (state) =>
    state.merge({
      specsListLoading: true,
      specsListError: null,
    }),

  [FETCH_SPECS_LIST_SUCCESS]: (state, action) =>
    state.merge({
      specsList: fromJS(action.payload),
      specsListLoading: false,
      specsListError: null,
    }),

  [FETCH_SPECS_LIST_FAILURE]: (state, action) =>
    state.merge({
      specsListLoading: false,
      specsListError: action.payload,
    }),

  [FETCH_SPEC_DETAILS_STARTED]: (state) =>
    state.merge({
      specDetailsLoading: true,
      specDetailsError: null,
    }),

  [FETCH_SPEC_DETAILS_SUCCESS]: (state, action) =>
    state.merge({
      selectedSpec: fromJS(action.payload),
      specDetailsLoading: false,
      specDetailsError: null,
    }),

  [FETCH_SPEC_DETAILS_FAILURE]: (state, action) =>
    state.merge({
      specDetailsLoading: false,
      specDetailsError: action.payload,
    }),

  [SAVE_SPEC_STARTED]: (state) =>
    state.merge({
      saveLoading: true,
      saveError: null,
    }),

  [SAVE_SPEC_SUCCESS]: (state, action) =>
    state.merge({
      saveLoading: false,
      saveError: null,
    }),

  [SAVE_SPEC_FAILURE]: (state, action) =>
    state.merge({
      saveLoading: false,
      saveError: action.payload,
    }),

  [SET_CURRENT_SPEC]: (state, action) => state.set('currentSpec', fromJS(action.payload)),

  [CLEAR_CURRENT_SPEC]: (state) => state.set('currentSpec', null),

  [FETCH_HEALTH_STARTED]: (state) =>
    state.merge({
      healthLoading: true,
      healthError: null,
    }),

  [FETCH_HEALTH_SUCCESS]: (state, action) =>
    state.merge({
      health: fromJS(action.payload),
      healthLoading: false,
      healthError: null,
    }),

  [FETCH_HEALTH_FAILURE]: (state, action) =>
    state.merge({
      healthLoading: false,
      healthError: action.payload,
    }),

  [DELETE_SPEC_STARTED]: (state) =>
    state.merge({
      deleteLoading: true,
      deleteError: null,
    }),

  [DELETE_SPEC_SUCCESS]: (state) =>
    state.merge({
      deleteLoading: false,
      deleteError: null,
    }),

  [DELETE_SPEC_FAILURE]: (state, action) =>
    state.merge({
      deleteLoading: false,
      deleteError: action.payload,
    }),

  [SAVE_ENDPOINT_SETTING_STARTED]: (state) =>
    state.merge({
      endpointSettingSaving: true,
      endpointSettingSaveError: null,
    }),

  [SAVE_ENDPOINT_SETTING_SUCCESS]: (state, action) =>
    state.merge({
      endpointSettingSaving: false,
      endpointSettingSaveError: null,
      lastSavedEndpointSetting: fromJS(action.payload),
    }),

  [SAVE_ENDPOINT_SETTING_FAILURE]: (state, action) =>
    state.merge({
      endpointSettingSaving: false,
      endpointSettingSaveError: action.payload,
    }),

  [UPDATE_UPSTREAM_STARTED]: (state) =>
    state.merge({
      upstreamUpdating: true,
      upstreamUpdateError: null,
    }),

  [UPDATE_UPSTREAM_SUCCESS]: (state, action) => {
    const updatedSpec = action.payload;
    const specsList = state.get('specsList');

    // Update the spec in the list with the new values
    const updatedList = specsList.map((spec) => {
      if (spec.get('id') === updatedSpec.id) {
        return spec.merge({
          upstreamEnvironment: updatedSpec.upstreamEnvironment,
          proxyMode: updatedSpec.proxyMode,
        });
      }
      return spec;
    });

    return state.merge({
      specsList: updatedList,
      upstreamUpdating: false,
      upstreamUpdateError: null,
    });
  },

  [UPDATE_UPSTREAM_FAILURE]: (state, action) =>
    state.merge({
      upstreamUpdating: false,
      upstreamUpdateError: action.payload,
    }),

  [FETCH_GLOBAL_CONFIG_STARTED]: (state) =>
    state.merge({
      globalConfigLoading: true,
      globalConfigError: null,
    }),

  [FETCH_GLOBAL_CONFIG_SUCCESS]: (state, action) =>
    state.merge({
      globalConfig: fromJS(action.payload),
      globalConfigLoading: false,
      globalConfigError: null,
    }),

  [FETCH_GLOBAL_CONFIG_FAILURE]: (state, action) =>
    state.merge({
      globalConfigLoading: false,
      globalConfigError: action.payload,
    }),

  [UPDATE_GLOBAL_CONFIG_STARTED]: (state) =>
    state.merge({
      globalConfigUpdating: true,
      globalConfigUpdateError: null,
    }),

  [UPDATE_GLOBAL_CONFIG_SUCCESS]: (state, action) =>
    state.merge({
      globalConfig: fromJS(action.payload),
      globalConfigUpdating: false,
      globalConfigUpdateError: null,
    }),

  [UPDATE_GLOBAL_CONFIG_FAILURE]: (state, action) =>
    state.merge({
      globalConfigUpdating: false,
      globalConfigUpdateError: action.payload,
    }),

  // Environment reducers
  [FETCH_ENVIRONMENTS_STARTED]: (state) =>
    state.merge({
      environmentsLoading: true,
      environmentsError: null,
    }),

  [FETCH_ENVIRONMENTS_SUCCESS]: (state, action) =>
    state.merge({
      environments: fromJS(action.payload),
      environmentsLoading: false,
      environmentsError: null,
    }),

  [FETCH_ENVIRONMENTS_FAILURE]: (state, action) =>
    state.merge({
      environmentsLoading: false,
      environmentsError: action.payload,
    }),

  [CREATE_ENVIRONMENT_STARTED]: (state) =>
    state.merge({
      createEnvironmentLoading: true,
      createEnvironmentError: null,
    }),

  [CREATE_ENVIRONMENT_SUCCESS]: (state) =>
    state.merge({
      createEnvironmentLoading: false,
      createEnvironmentError: null,
    }),

  [CREATE_ENVIRONMENT_FAILURE]: (state, action) =>
    state.merge({
      createEnvironmentLoading: false,
      createEnvironmentError: action.payload,
    }),

  [DELETE_ENVIRONMENT_STARTED]: (state) =>
    state.merge({
      deleteEnvironmentLoading: true,
      deleteEnvironmentError: null,
    }),

  [DELETE_ENVIRONMENT_SUCCESS]: (state) =>
    state.merge({
      deleteEnvironmentLoading: false,
      deleteEnvironmentError: null,
    }),

  [DELETE_ENVIRONMENT_FAILURE]: (state, action) =>
    state.merge({
      deleteEnvironmentLoading: false,
      deleteEnvironmentError: action.payload,
    }),

  [FETCH_ENVIRONMENT_DETAIL_STARTED]: (state) =>
    state.merge({
      environmentDetailLoading: true,
    }),

  [FETCH_ENVIRONMENT_DETAIL_SUCCESS]: (state, action) =>
    state.merge({
      environmentDetail: fromJS(action.payload),
      environmentDetailLoading: false,
    }),

  [FETCH_ENVIRONMENT_DETAIL_FAILURE]: (state, action) =>
    state.merge({
      environmentDetailLoading: false,
    }),

  [SET_ACTIVE_ENVIRONMENT]: (state, action) =>
    state.set('activeEnvironment', action.payload ? fromJS(action.payload) : null),

  [UPSERT_ENV_SPEC_SETTING_STARTED]: (state) =>
    state.merge({
      envSpecSettingUpdating: true,
      envSpecSettingError: null,
    }),

  [UPSERT_ENV_SPEC_SETTING_SUCCESS]: (state) =>
    state.merge({
      envSpecSettingUpdating: false,
      envSpecSettingError: null,
    }),

  [UPSERT_ENV_SPEC_SETTING_FAILURE]: (state, action) =>
    state.merge({
      envSpecSettingUpdating: false,
      envSpecSettingError: action.payload,
    }),

  [UPSERT_ENV_ENDPOINT_SETTING_STARTED]: (state) =>
    state.merge({
      envEndpointSettingUpdating: true,
      envEndpointSettingError: null,
    }),

  [UPSERT_ENV_ENDPOINT_SETTING_SUCCESS]: (state, action) =>
    state.merge({
      envEndpointSettingUpdating: false,
      envEndpointSettingError: null,
      lastSavedEndpointSetting: fromJS(action.payload),
    }),

  [UPSERT_ENV_ENDPOINT_SETTING_FAILURE]: (state, action) =>
    state.merge({
      envEndpointSettingUpdating: false,
      envEndpointSettingError: action.payload,
    }),
};

export default reducers;
